/* Bloomfold Black Friday VIP opt-in: countdown, aanmeldstatus, Klaviyo-koppeling, FAQ, sticky balk. */
(function () {
  if (window.BfVip) { return; }
  var cfgEl = document.querySelector('[data-bfv-config]');
  if (!cfgEl) { return; }
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) { cfg = {}; }
  var KEY = 'bfvip_signed_' + (cfg.key || '2026');
  var TARGET = new Date(cfg.target || '2026-11-01T08:00:00+01:00').getTime();
  var html = document.documentElement;
  var pad = function (n) { return String(Math.max(0, n)).padStart(2, '0'); };
  var signedEmail = '';
  var picks = [];

  /* ---------- countdown ---------- */
  function tick() {
    var s = Math.floor(Math.max(0, TARGET - Date.now()) / 1000);
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), ss = s % 60;
    var shortTxt = d + 'd ' + pad(h) + 'u ' + pad(m) + 'm ' + pad(ss) + 's';
    document.querySelectorAll('[data-bfv-cd="short"]').forEach(function (el) { el.textContent = shortTxt; });
    document.querySelectorAll('[data-bfv-cd="days"]').forEach(function (el) { el.textContent = String(d); });
    document.querySelectorAll('[data-bfv-cd="days-label"]').forEach(function (el) { el.textContent = d === 1 ? 'dag' : 'dagen'; });
    document.querySelectorAll('[data-bfv-band]').forEach(function (el) {
      var txt;
      if (s === 0) { txt = 'De sale is <strong>begonnen.</strong>'; }
      else if (d === 0) { txt = 'Nog <strong>' + (h === 0 ? 'minder dan een uur' : h + ' uur') + '</strong> tot de sale.'; }
      if (txt && el.innerHTML !== txt) { el.innerHTML = txt; }
    });
    document.querySelectorAll('[data-bfv-tiles]').forEach(function (box) {
      var vals = { d: pad(d), h: pad(h), m: pad(m), s: pad(ss) };
      box.querySelectorAll('[data-bfv-unit]').forEach(function (el) { var v = vals[el.getAttribute('data-bfv-unit')]; if (el.textContent !== v) { el.textContent = v; } });
    });
  }
  tick();
  setInterval(tick, 1000);

  /* ---------- aanmeldstatus ---------- */
  function isSigned() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function remember() { try { localStorage.setItem(KEY, '1'); } catch (e) { /* privé-modus */ } }
  function applySigned() {
    html.classList.add('bfv-signed');
    document.body.classList.remove('bfv-has-sticky');
    document.querySelectorAll('[data-bfv-pass]').forEach(function (el) { el.textContent = 'Toegang bevestigd'; });
    var sticky = document.querySelector('.bfv-sticky'); if (sticky) { sticky.classList.remove('is-visible'); }
  }
  function showHeroStep(step) {
    var hero = document.querySelector('[data-bfv-form="hero"]');
    if (!hero) { return; }
    var interest = hero.querySelector('[data-bfv-interest]'), done = hero.querySelector('[data-bfv-done]');
    if (interest) { interest.hidden = step !== 'interest'; }
    if (done) { done.hidden = step !== 'done'; }
  }
  function onSubmitted(email) {
    if (email) { signedEmail = email; }
    remember();
    applySigned();
    showHeroStep('interest');
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'bf_vip_signup', source: 'opt-in' }); } catch (e) { /* geen GTM */ }
    try { if (window.Shopify && Shopify.analytics) { Shopify.analytics.publish('bf_vip_signup', { source: 'opt-in' }); } } catch (e) { /* Meta Lead via Klantgebeurtenissen: BF VIP Lead */ }
  }
  function finish() {
    if (picks.length && window.klaviyo && typeof window.klaviyo.push === 'function') {
      var props = { 'Black Friday 2026 interesses': picks.join(', ') };
      if (signedEmail) { props.$email = signedEmail; }
      window.klaviyo.push(['identify', props]);
    }
    showHeroStep('done');
  }

  if (isSigned()) { applySigned(); showHeroStep('done'); } else { showHeroStep(null); }

  /* Klaviyo embedded form: submit-event */
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail; if (!d) { return; }
    if (cfg.formId && d.formId && String(d.formId) !== String(cfg.formId)) { return; }
    if (d.type === 'submit') {
      var email = d.metaData && (d.metaData.$email || d.metaData.email);
      onSubmitted(email);
    }
  });

  /* ---------- klikken ---------- */
  function focusHero() {
    var hero = document.querySelector('[data-bfv-form="hero"]');
    var target = hero || document.querySelector('.bfv-hero');
    if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    var input = hero && hero.querySelector('input[type="email"]');
    if (input) { setTimeout(function () { input.focus({ preventScroll: true }); }, 450); }
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-bfv-act]');
    if (!el) { return; }
    var act = el.getAttribute('data-bfv-act');
    if (act === 'focus') { e.preventDefault(); focusHero(); }
    else if (act === 'chip') { var on = el.getAttribute('aria-pressed') === 'true'; el.setAttribute('aria-pressed', on ? 'false' : 'true'); var v = el.getAttribute('data-bfv-value'); picks = on ? picks.filter(function (p) { return p !== v; }) : picks.concat([v]); }
    else if (act === 'finish') { finish(); }
    else if (act === 'faq') {
      var item = el.closest('.bfv-faq__item'), list = item && item.parentNode;
      var open = item.classList.contains('is-open');
      if (list) { list.querySelectorAll('.bfv-faq__item').forEach(function (i) { i.classList.remove('is-open'); i.querySelector('.bfv-faq__q').setAttribute('aria-expanded', 'false'); }); }
      if (!open) { item.classList.add('is-open'); el.setAttribute('aria-expanded', 'true'); }
    }
  });

  /* ---------- sticky balk (mobiel) ---------- */
  var sticky = document.querySelector('.bfv-sticky');
  if (sticky && 'IntersectionObserver' in window) {
    var heroForm = document.querySelector('[data-bfv-form="hero"]'), closingForm = document.querySelector('[data-bfv-form="closing"]');
    var seen = { hero: true, closing: false }, passedHero = false;
    var update = function () {
      var show = passedHero && !seen.hero && !seen.closing && !isSigned();
      sticky.classList.toggle('is-visible', show);
      document.body.classList.toggle('bfv-has-sticky', show);
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.target === heroForm) { seen.hero = en.isIntersecting; if (!en.isIntersecting && en.boundingClientRect.top < 0) { passedHero = true; } }
        if (en.target === closingForm) { seen.closing = en.isIntersecting; }
      });
      update();
    }, { threshold: 0.1 });
    if (heroForm) { io.observe(heroForm); }
    if (closingForm) { io.observe(closingForm); }
  }

  window.BfVip = { focus: focusHero, signed: isSigned };
})();
